
import Vue from 'vue';

import SectionHeading from '@/components/general/utils/SectionHeading.vue';
import PricingCard from '@/components/home/PricingCard.vue';

export default Vue.extend({
	name: 'Pricing',

	components: { SectionHeading, PricingCard },

	props: {
		landingPage: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			l: true,
			xl: true,
			xxl: true
		};
	},

	methods: {
		removeMissingSize(val: string) {
			if (val === 'L') {
				this.l = false;
			} else if (val === 'XL') {
				this.xl = false;
			} else if (val === 'XXL') {
				this.xxl = false;
			}
		}
	}
});
